import { useAuthStore } from '@/stores/login'
import { useUsersStore } from '@/stores/users'
import { updateUserInfo } from '@/utils/userInfo'
import { getQueryString } from '@/utils'
// import { showDialog } from 'vant'
// import router from '@/router'
// import i18n from '@/locales'

export const isApp = window.navigator.userAgent.indexOf('sandytalkApp') > -1;

export const skipLoginScreen = () => {
  // alert("获取登录皮肤")
  window.postMessage(JSON.stringify({ type: 'skipLoginScreen' }))
}

export const skipBack = () => {
  window.postMessage(JSON.stringify({ type: 'skipBack' }))
}

// 修改getToken方法，适配新的App传参方式
export const getToken = () => {
  // 检查新的App方法是否存在
  if (typeof (window as any).sandytalkGetToken === 'function') {
    try {
      const token = (window as any).sandytalkGetToken()
      window.h5Methods.setToken(token)
      return
    } catch (error) {
      console.error('调用sandytalkGetToken失败:', error)
    }
  }

  window.postMessage(JSON.stringify({ type: 'getToken' }))
  return
}

// 新增获取tenantId方法，适配新的App传参方式
export const getTenantId = () => {
  // 检查新的App方法是否存在
  if (typeof (window as any).sandytalkGetTenantId === 'function') {
    try {
      const tenantId = (window as any).sandytalkGetTenantId()
      console.log('通过sandytalkGetTenantId获取到tenantId:', tenantId)

      // 存储到localStorage
      if (tenantId && tenantId !== 'undefined' && tenantId !== 'null') {
        localStorage.setItem('sandsTalkTenantId', tenantId)
        return tenantId
      } else {
        console.warn('获取到的tenantId无效:', tenantId)
      }
    } catch (error) {
      console.error('调用sandytalkGetTenantId失败:', error)
    }
  } else {
    console.warn('window.sandytalkGetTenantId 方法不存在')
  }

  return null
}

export const getLang = () => {
  return getQueryString('sandytalkLang')
}

const u = navigator.userAgent
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
window.h5Methods = {
  setToken() { },
  backHandle() { }
}

const registerMethod = () => {
  const usersStore = useUsersStore()
  const { setCollegeId } = usersStore
  const listener = function (e: any) {
    try {
      if (!e) return null
      if (e.data === undefined || e.data === "undefined") return null
      const data = JSON.parse(e.data)

      if (data.type === 'setCollegeId') {
        console.log('setCollegeId')
        setCollegeId(data.payload)
      } else if (data.type === 'setToken') {
        window.h5Methods.setToken(data.payload)
      } else if (data.type === 'backHandle') {
        window.h5Methods.backHandle()
      }
    } catch (err) {
      console.log(err)
    }
  }
  if (isAndroid) {
    document.addEventListener('message', listener)
  } else {
    window.addEventListener('message', listener)
  }
}

interface AppLoginParams {
  callback?: () => void
}

// 修改appLogin方法，优先使用新的sandytalkGetToken方法
export const appLogin = async (data: AppLoginParams) => {
  const { callback = () => { } } = data

  // 处理token的通用方法
  const handleToken = async (token: string) => {
    if (token && token !== 'undefined' && token !== 'null') {
      const authStore = useAuthStore()
      authStore.setAccessToken(token)
      localStorage.setItem('sandsTalkToken', token)
      // 设置fromLogin标记，用于广告显示
      localStorage.setItem('fromLogin', 'true')
      await updateUserInfo()
      callback()
    } else {
      console.warn('获取到的token无效:', token)
    }
  }

  // 回退到旧版本的postMessage方式
  console.log('使用旧版本的postMessage方式获取token')
  registerMethod()
  window.h5Methods.setToken = async (token: string) => {
    await handleToken(token)
  }

  // 优先尝试新的App方法
  if (typeof (window as any).sandytalkGetToken === 'function') {
    getToken()
    getTenantId()
  } else {
    setTimeout(() => {
      getToken()
      getTenantId()
    }, 200)
  }
}

interface FileDownloadParams {
  fileType: string
  docName: string
  fromUrl: string
  callback?: (success: boolean, destPath?: string) => void
  callbackPercent?: (value: { percent: number }) => void
  toastEnable?: boolean
  messageFn?: (value: string) => void
}
export const fileDownload = (payload: FileDownloadParams) => {
  window.postMessage(JSON.stringify({ type: 'fileDownload', payload }))
}

interface SkipCourseDetailScreenParams {
  id: number
  courseId: number
  courseType: string
  endingType: string
  channel?: string
  trySeeSpuId?: number
}
export const skipCourseDetailScreen = (payload: SkipCourseDetailScreenParams) => {
  let payloadParams = {
    id: undefined as number | undefined,
    courseWareId: undefined as number | undefined,
    courseType: payload.courseType,
    endingType: payload.endingType,
    channel: payload.channel,
    trySeeSpuId: payload.trySeeSpuId
  }

  if (payload.courseId === -1) {
    // 课程包
    payloadParams.id = payload.id as number
  } else if (payload.id === -1) {
    // 课件
    payloadParams.id = payload.courseId as number
  } else if (payload.id !== -1 && payload.courseId !== -1) {
    // 课程包下的课件
    payloadParams.id = payload.id
    payloadParams.courseWareId = payload.courseId as number
  }
  console.log('-------payloadParams------------', payloadParams)
  window.postMessage(
    JSON.stringify({
      type: 'skipCourseDetailScreen',
      payload: payloadParams
    })
  )
}

interface ShowShareModalParams {
  title: string
  url: string
  previewUrl: string
  description: string
}
export const showShareModal = (payload: ShowShareModalParams) => {
  window.postMessage(JSON.stringify({ type: 'showShareModal', payload }))
}

export const setTitle = (payload: string) => {
  window.postMessage(JSON.stringify({ type: 'setTitle', payload }))
}

export const hideNativeLoading = () => {
  window.postMessage(JSON.stringify({ type: 'hideLoading' }))
}
